import React, {useCallback} from 'react';

import AppModal from '../../../../common/components/CustomModal/AppModal';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {useColorThemeType} from '../../../../../src/appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

interface CustomSubModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const CustomSubModal: React.FC<CustomSubModalProps> = props => {
  const theme = useColorThemeType('main');
  const {title, body, button} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const onClick = useCallback(() => {
    props?.onSubmit();
    props?.onClose();
  }, [props]);

  return (
    <AppModal
      isOpen={props?.isOpen}
      onClose={() => props?.onClose()}
      topCTAHandelr={onClick}
      title={title?.impInfo}
      subTitle={body?.createRequest}
      ctaBottomTitle={button?.cancel}
      ctaTopTitle={button?.okay}
      topCTAColor={theme?.background.green[100]}
      // loading={loading}
    />
  );
};

export default React.memo(CustomSubModal);
